<script setup lang="ts">
import ClientOnly from '@/components/utils/ClientOnly.vue';
import Calculator from './Calculator.vue';
</script>

<template>
  <!-- reserve space. -->
  <div class="min-h-246 sm:min-h-230 lg:min-h-135" >
    <ClientOnly>
      <Calculator />
    </ClientOnly>    
  </div>
</template>